<template>
  <div class="cron" :val="value_">
    <el-tabs v-model="activeName">
      <el-tab-pane label="分" name="m">
        <second-and-minute v-model="mVal" lable="分" />
      </el-tab-pane>
      <el-tab-pane label="时" name="h">
        <hour v-model="hVal" lable="时" />
      </el-tab-pane>
      <el-tab-pane label="日" name="d">
        <day v-model="dVal" lable="日" />
      </el-tab-pane>
      <el-tab-pane label="月" name="month">
        <month v-model="monthVal" lable="月" />
      </el-tab-pane>
      <el-tab-pane label="周" name="week">
        <week v-model="weekVal" lable="周" />
      </el-tab-pane>
      <el-tab-pane label="年" name="year">
        <year v-model="yearVal" lable="年" />
      </el-tab-pane>
    </el-tabs>
    <div class="border1px">
      <p v-for="item in finalTitle" :key="item">{{ item }}</p>
    </div>
  </div>
</template>
<script>
import SecondAndMinute from './secondAndMinute';
import hour from './hour';
import day from './day';
import month from './month';
import week from "./week";
import year from './year';
export default {
  components: {
    SecondAndMinute,
    hour,
    day,
    month,
    week,
    year
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isFirstEntry: false,
      changeFlag: false, //是否有修改
      //
      activeName: 'm',
      sVal: '0',
      mVal: '',
      hVal: '',
      dVal: '',
      monthVal: '',
      weekVal: "",
      yearVal: '',
      finalTitle: [],
      titleTxt:[]
    };
  },
  computed: {
    value_() {
      if (!this.dVal && !this.weekVal) {
        return "";
      }
      if (this.dVal === "?" && this.weekVal === "?") {
        this.$message.error({ message: '日期与星期不可以同时为"不指定"' });
      }
      if (this.dVal !== "?" && this.weekVal !== "?") {
        this.$message.error({ message: '日期与星期必须有一个为"不指定"' });
      }
      const v = `0 ${this.mVal} ${this.hVal} ${this.dVal} ${this.monthVal} ${this.weekVal} ${this.yearVal}`;
      if (v !== this.value) {
        this.$emit("input", v,this.titleTxt);
      }
      return v;
    },
    cronexPression() {
      return `0 ${this.mVal || '*'} ${this.hVal || '*'} ${this.dVal || '*'} ${this.monthVal || '*'} ${this.weekVal || "*"} ${this.yearVal || '*'}`;
    }
  },
  watch: {
    value(a, b) {
      this.updateVal();
    },
    cronexPression(a, b) {
      this.finalTitle = [];
      this.titleTxt = [];
      let lable = ['秒', '分', '时', '日', '月', '星期', '年'];
      let time = ['s', 'm', 'h', 'd', 'month', 'week', 'year'];
      // 每出现次数
      let everyCount = 0;
      // 周期出现次数
      let periodCount = 0;
      // 循环出现次数
      let loopCount = 0;
      let arr = a.split(' ');
      //多次出现*号将不为第一次出现的项变为未指定
      let mapArr = arr.map((item, index) => {
        if (item == '*' && index != arr.indexOf('*')) {
          return (item = '?');
        } else {
          return item;
        }
      });
      let loopLastindex = null;
      mapArr.forEach((item, index) => {
        if (item.indexOf('/') != -1) {
          loopLastindex = index;
        }
      });
      mapArr.forEach((item, index) => {
        let str = '';
        if (item.indexOf('-') != -1) {
          if (index == 5) {
            str = `${[lable[index]]}${item.split('-')[0]}至${[lable[index]]}${item.split('-')[1]}`;
          } else {
            str = `${item.split('-')[0]}至${item.split('-')[1]}${[lable[index]]}`;
          }
          periodCount++;
        } else if (item.indexOf('/') != -1) {
          if (index == 5) {
            if (index == loopLastindex) {
              str = `从${[lable[index]]}${item.split('/')[0]}开始，每${item.split('/')[1]}天`;
            } else {
              str = `${[lable[index]]}${item.split('/')[0]}，每${item.split('/')[1]}天`;
            }
          } else if (index == 2) {
            if (index == loopLastindex) {
              str = `从${item.split('/')[0]}${[lable[index]]}开始，每${item.split('/')[1]}小时`;
            } else {
              str = `${item.split('/')[0]}${[lable[index]]}，每${item.split('/')[1]}小时`;
            }
          } else if (index == 4) {
            if (index == loopLastindex) {
              str = `从${item.split('/')[0]}${[lable[index]]}开始，每${item.split('/')[1]}个月`;
            } else {
              str = `${item.split('/')[0]}${[lable[index]]}，每${item.split('/')[1]}个月`;
            }
          } else {
            if (index == loopLastindex) {
              str = `从${item.split('/')[0]}${[lable[index]]}开始，每${item.split('/')[1]}${[lable[index]]}`;
            } else {
              str = `${item.split('/')[0]}${[lable[index]]}，每${item.split('/')[1]}${[lable[index]]}`;
            }
          }
          loopCount++;
        } else if (item.indexOf('W') != -1) {
          str = `本月${item.split('W')[0]}${[lable[index]]},最近的工作日`;
        } else if (item.indexOf('L') != -1) {
          if (index == 5) {
            str = `本月最后一个${[lable[index]]}${item.split('L')[0]}`;
          } else {
            str = `本月最后一天`;
          }
        } else if (item.indexOf('#') != -1) {
          str = `本月第${item.split('#')[0]}周,星期${item.split('#')[1]}`;
        } else if (item.indexOf('*') != -1) {
          // str = `每${[lable[index]]}`;
          if (everyCount) {
            str = '';
          } else {
            str = `每${[lable[index]]}`;
            everyCount++;
          }
        } else if (item.indexOf(',') != -1) {
          if (index == 5) {
            str = `${[lable[index]]}${item}`;
          } else {
            str = `${item}${[lable[index]]}`;
          }
        } else if (item.indexOf('?') != -1 || index == 0) {
          str = ` `;
        } else if (typeof Number(item) === 'number' && !isNaN(Number(item))) {
          if (index == 5) {
            str = `${[lable[index]]}${Number(item)}`;
          } else {
            str = `${Number(item)}${[lable[index]]}`;
          }
        } else {
          str = '';
        }
        time[index] = str;
      });
      let newArr = arr;
      time.reverse()
      newArr.reverse();
      //周期
      let periodArr = this.findall(newArr, '-');
      // 循环
      let loopArr = this.findall(newArr, '/');
      // 指定周
      let specifyArr = this.findall(newArr, '#');
      // 工作日
      let workArr = this.findall(newArr, 'W');
      // 最后一个
      let lastArr = this.findall(newArr, 'L');
      // 每
      let everyArr = this.findall(newArr, '*');
      // 指定
      let appointArr = [];
      newArr.forEach((item, index) => {
        if ((typeof Number(item) === 'number' && !isNaN(Number(item)) && index !== newArr.length - 1) || item.indexOf(',') != -1) {
          appointArr.push(index);
        }
      });
      let periodStr = this.statistics(periodArr, time);
      let loopStr = this.statistics(loopArr, time);
      let specifyStr = this.statistics(specifyArr, time);
      let workStr = this.statistics(workArr, time);
      let lastStr = this.statistics(lastArr, time);
      let everyStr = this.statistics(everyArr, time);
      let appointStr = this.statistics(appointArr, time);
      if (everyStr.length) {
        this.finalTitle.push(`触发频次：${everyStr[everyStr.length - 1]}执行一次`);
        this.titleTxt.push(`${everyStr[everyStr.length - 1]}执行一次`);
      }
      if (periodStr.length) {
        this.finalTitle.push(`触发周期：${periodStr.join('的')}`);
        this.titleTxt.push(`${periodStr.join('的')}`);
      }
      if (loopStr.length) {
        this.finalTitle.push(`触发循环：${loopStr.join('的')}执行一次`);
        this.titleTxt.push(`${loopStr.join('的')}执行一次`);
      }
      if (specifyStr.length) {
        this.finalTitle.push(`指定周：${specifyStr.join('的')}`);
        this.titleTxt.push(`${specifyStr.join('的')}`);
      }
      if (workStr.length) {
        this.finalTitle.push(`${workStr.join('')}`);
        this.titleTxt.push(`${workStr.join('')}`);
      }
      if (lastStr.length) {
        this.finalTitle.push(`${lastStr[lastStr.length - 1]}`);
        this.titleTxt.push(`${lastStr[lastStr.length - 1]}`);
      }
      if (appointStr.length) {
        this.finalTitle.push(`指定时间：${appointStr.join('的')}`);
        this.titleTxt.push(`${appointStr.join('的')}`);
      }
    }
  },
  created() {
    this.updateVal();
  },
  methods: {
    findall(arr, x) {
      let results = [];
      arr.forEach((el, i) => el.indexOf(x) != -1 && results.push(i));
      return results;
    },
    statistics(a, time) {
      let results = [];
      if (a.length) {
        a.forEach((j, jndex) => {
          results.push(time[j]);
        });
      }
      return results;
    },
    updateVal() {
      if (!this.value) {
        return;
      }
      console.log('this.value',this.value);
      
      const arrays = this.value.split(' ');
      console.log('arrays',arrays);
      
      this.sVal = arrays[0];
      this.mVal = arrays[1];
      this.hVal = arrays[2];
      this.dVal = arrays[3];
      this.monthVal = arrays[4];
      this.weekVal = arrays[5];
      this.yearVal = arrays[6] || '';
    }
  }
};
</script>
<style lang="css" scoped>
.cron {
  text-align: left;
  padding: 10px;
  background: #fff;
}

/deep/ .el-tabs__header {
  margin: 0px;
}
</style>
